import { Service } from '@genial/services';
import { Utils } from '@genial/utils';
import { selectorFamily } from 'recoil';

import { normalizeDividendHistory } from './normalizer';
import { DividendHistoryEntityNormalized, ReturnTypeOf_RendaVariavelObterProventos } from './types';

export const dividendHistoryQuery = selectorFamily<
  DividendHistoryEntityNormalized[],
  {
    searchTerm: string;
    startDate: Date;
    endDate: Date;
    approvalDate?: Date | null;
    updateDate?: Date | null;
    dueDate?: Date | null;
    assetValueMin?: number | null;
    assetValueMax?: number | null;
  }
>({
  key: 'cockpit/dividendHistoryQuery',
  get:
    ({
      searchTerm,
      startDate,
      endDate,
      approvalDate,
      updateDate,
      dueDate,
      assetValueMin,
      assetValueMax,
    }) =>
    async ({ get }) => {
      let data = get(dividendHistoryQueryByDate({ startDate, endDate }));

      if (searchTerm) {
        data = data.filter(
          (item) =>
            item.assetName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.isinCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.negotiationCode.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }

      if (approvalDate) {
        const approvalDateNormalized = Utils.Mask.DateFormat(approvalDate, 'dd/MM/yyyy');
        data = data.filter((item) => item.approvalDateNormalized === approvalDateNormalized);
      }

      if (updateDate) {
        const updateDateNormalized = Utils.Mask.DateFormat(updateDate, 'dd/MM/yyyy');
        data = data.filter((item) => item.updateDateNormalized === updateDateNormalized);
      }

      if (dueDate) {
        const dueDateNormalized = Utils.Mask.DateFormat(dueDate, 'dd/MM/yyyy');
        data = data.filter((item) => item.dueDateNormalized === dueDateNormalized);
      }

      if (
        assetValueMin !== undefined &&
        assetValueMin !== null &&
        assetValueMax !== undefined &&
        assetValueMax !== null
      ) {
        data = data.filter(
          (item) => item.assetValue >= assetValueMin && item.assetValue <= assetValueMax
        );
      } else if (assetValueMin !== undefined && assetValueMin !== null) {
        data = data.filter((item) => item.assetValue >= assetValueMin);
      } else if (assetValueMax !== undefined && assetValueMax !== null) {
        data = data.filter((item) => item.assetValue <= assetValueMax);
      }

      return data;
    },
});

export const dividendHistoryQueryByDate = selectorFamily<
  DividendHistoryEntityNormalized[],
  { startDate: Date; endDate: Date }
>({
  key: 'cockpit/dividendHistoryQueryByDate',
  get:
    ({ startDate, endDate }) =>
    async () => {
      const data = await Service.External.Extranet.RendaVariavel.V1.rendaVariavelObterProventos({
        request: {
          dataFim: endDate,
          dataInicio: startDate,
        },
        screenName: 'cockpit',
      });

      return normalizeDividendHistory(data as ReturnTypeOf_RendaVariavelObterProventos);
    },
});
